import * as React from 'react';
import { makeStyles, createStyles, Typography, Box } from '@material-ui/core';
import cn from 'classnames';
import Separator from '../Separator/Separator';
import WaBtn from './WaBtn';
import RenderText from '../../dictionaries/RenderText';
import WAIcon from '../../assets/icons/WAIcon';
import { TranquiTheme } from '../../containers/App/theme';
import { BankType } from '../../generated/graphql';
import { useGetGlobalSettingDomainByEntity } from '../../utils/useGetGlobalSettingDomainByEntity';

interface WaCardProps {
  waMessage?: string;
  withSeparator?: boolean;
  withIcon?: boolean;
  className?: string;
  bank?: BankType;
}

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: theme.spacing(0, 3),
    boxSizing: 'border-box',
    maxWidth: 500,
    margin: 'auto',
  },
  title: {
    ...theme.typography.body1,
    fontWeight: 600,
    color: theme.palette.indigo.main,
    marginBottom: theme.spacing(2),
  },
  text: {
    ...theme.typography.body2,
    color: theme.palette.text2.main,
    marginBottom: theme.spacing(1),
  },
  contactLine: {
    ...theme.typography.body2,
    color: theme.palette.text2.main,
    marginBottom: theme.spacing(1),
    '& a': {
      color: theme.palette.text2.main,
    },
  },
}));

const WaCard: React.FC<WaCardProps> = (props) => {
  const classes = useStyles();
  const { waMessage, withSeparator, withIcon, className, bank } = props;

  const domainWhatsapp = useGetGlobalSettingDomainByEntity('domainWhatsapp');
  const domainCalls = useGetGlobalSettingDomainByEntity('domainCalls');

  if (!domainWhatsapp || !domainCalls) return null;

  const whatsappNumber = domainWhatsapp.formattedNumber || domainWhatsapp.number;
  const callNumber = domainCalls.formattedNumber || domainCalls.number;
  const callNumberRaw = domainCalls.number;

  return (
    <>
      {withSeparator && <Separator className="my-3" />}
      <Box className={cn(classes.root, className)} data-testid="wa-card">
        {withIcon && <WAIcon className="mb-1" data-testid="wa-card__icon" />}
        <Typography className={classes.title}><RenderText textKey="action_wa_button_title" /></Typography>
        <Typography className={classes.text}>
          <RenderText data-testid="wa-card-description" textKey="action_wa_button_description" />
        </Typography>
        <Typography className={classes.contactLine} data-testid="wa-card-call-line">
          <RenderText
            textKey="action_call_line"
            context={{ phoneNumber: callNumber, phoneNumberRaw: callNumberRaw }}
            isMarkdown
          />
        </Typography>
        <Typography className={classes.contactLine} data-testid="wa-card-wa-line">
          <RenderText textKey="action_wa_line" context={{ phoneNumber: whatsappNumber }} isMarkdown />
        </Typography>
        <Box className={classes.text}>
          <WaBtn msg={waMessage} bank={bank} />
        </Box>
      </Box>
    </>
  );
};

export default WaCard;
